import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../assets/logo/logo.webp";
import { useGlobalContext } from "../../ContextApi/GlobalContext";
import { removeAuthorization } from "../../Functions/AuthFunction";

// Mock User Data
const MOCK_USER = {
  name: "Rahul",
  email: "rahul@eventix.com",
  avatar: "https://ui-avatars.com/api/?name=Rahul+Biswas&background=D4AF37&color=0B1F33"
};

const Header = ({ isOpenLogin, isOpenPlan }) => {
  const { state, dispatch } = useGlobalContext()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);

  // Set to true to test the logged-in state
  const isLoggedIn = state?.authToken;

  const location = useLocation();
  const dropdownRef = useRef(null);

  const navLinks = [
    // { name: "Home", path: "/" },
    // { name: "Events", path: "/events" },
    // { name: "Explore", path: "/explore" },
    // { name: "Expertise", path: "/services"},
    // { name: "Gallery", path: "/gallery" },
    // { name: "Contact", path: "/contact" },
  ];

  // Close menus on route change or outside click
  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsProfileDropdownOpen(false);
  }, [location]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsProfileDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    removeAuthorization();
    dispatch({ authToken: false, dashboardData: false });
  };

  return (
    <>
      <header className="fixed top-0 left-0 w-full z-[999999] bg-white/95 backdrop-blur-md border-b border-gray-100 shadow-sm transition-all duration-300">

        <div className="w-[95%] md:w-[90%] mx-auto h-[80px] flex items-center justify-between relative">

          {/* Logo */}
          <div className="flex items-center cursor-pointer">
            <Link to={'/'} className="flex items-center justify-center">
              <img src={Logo} alt="eventix-logo" className="h-[60px] md:h-[90px] object-contain -ml-4" />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`group relative text-base font-semibold transition-colors py-2 ${location.pathname === link.path
                  ? "text-[#D4AF37]"
                  : "text-gray-600 hover:text-[#D4AF37]"
                  }`}
              >
                {link.name}
                <span className={`absolute bottom-0 left-0 h-0.5 bg-[#D4AF37] transition-all duration-300 ${location.pathname === link.path ? "w-full" : "w-0 group-hover:w-full"
                  }`}></span>
              </Link>
            ))}
          </nav>

          {/* Actions */}
          <div className="flex items-center gap-4">

            {/* Desktop Actions */}
            <div className="hidden lg:flex items-center gap-4">
              {/* {isLoggedIn ? (
                <div className="relative" ref={dropdownRef}>
                  <button
                    onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)}
                    className="flex items-center justify-center w-10 h-10 rounded-full border-2 border-transparent hover:border-[#D4AF37] focus:outline-none transition-all active:scale-95 overflow-hidden"
                    aria-label="User Profile"
                  >
                    <img
                      src={MOCK_USER.avatar}
                      alt="User Avatar"
                      className="w-full h-full object-cover"
                    />
                  </button>
                  {isProfileDropdownOpen && (
                    <div className="absolute right-0 mt-3 w-56 bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden animate-[fadeInUp_0.2s_ease-out] origin-top-right z-50">
                      <div className="px-5 py-4 border-b border-gray-100 bg-gray-50">
                        <p className="text-sm font-bold text-[#0B1F33] truncate">{MOCK_USER.name}</p>
                        <p className="text-xs text-gray-500 truncate">{MOCK_USER.email}</p>
                      </div>

                      <div className="py-1">
                        <Link to="/dashboard" className="flex items-center gap-2 px-5 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-[#D4AF37] transition-colors">
                          <span className="material-symbols-outlined text-lg">dashboard</span>
                          Dashboard
                        </Link>
                      </div>

                      <div className="border-t border-gray-100 py-1">
                        <button onClick={handleLogout} className="w-full text-left flex items-center gap-2 px-5 py-2.5 text-sm font-medium text-red-500 hover:bg-red-50 transition-colors">
                          <span className="material-symbols-outlined text-lg">logout</span>
                          Sign out
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <button
                  onClick={isOpenLogin}
                  className="text-[#0B1F33] font-semibold text-base hover:text-[#D4AF37] transition-colors"
                >
                  Log In
                </button>
              )} */}

              {/* <button onClick={isOpenPlan} className="bg-[#D4AF37] hover:bg-[#c5a02e] text-[#0B1F33] font-bold text-base px-6 py-3 rounded-full shadow-md transition-all active:scale-95 whitespace-nowrap">
                Plan Your Event
              </button> */}
            </div>

            {/* Mobile Menu Toggle */}
            <button onClick={isOpenPlan} className="bg-[#D4AF37] hover:bg-[#c5a02e] text-[#0B1F33] font-bold text-base px-6 py-3 rounded-full shadow-md transition-all active:scale-95 whitespace-nowrap">
              Plan Your Event
            </button>
            {/* <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="p-2 -mr-2 rounded-full hover:bg-gray-100 text-[#0B1F33] transition-colors lg:hidden active:scale-95"
            >
              <span className="material-symbols-outlined text-3xl">
                {isMobileMenuOpen ? 'close' : 'menu'}
              </span>
            </button> */}
          </div>
        </div>

        {/* --- MOBILE DRAWER --- */}
        <div
          className={`lg:hidden fixed inset-x-0 top-[80px] h-[calc(100vh-80px)] bg-white/95 backdrop-blur-xl border-t border-gray-100 shadow-2xl transition-all duration-300 ease-in-out transform origin-top overflow-y-auto ${isMobileMenuOpen ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4 pointer-events-none'}`}
        >
          <div className="p-4 flex flex-col h-full">

            {/* User Info (Mobile) */}
            {isLoggedIn && (
              <div className="bg-gray-50 rounded-2xl p-4 mb-4 flex items-center gap-4 border border-gray-100">
                <img src={MOCK_USER.avatar} alt="User" className="w-12 h-12 rounded-full border-2 border-[#D4AF37] object-cover" />
                <div className="flex-1 min-w-0">
                  <p className="font-bold text-lg text-[#0B1F33] truncate">{MOCK_USER.name}</p>
                  <p className="text-xs text-gray-500 truncate">{MOCK_USER.email}</p>
                </div>
              </div>
            )}

            {/* Nav Links (Mobile) */}
            <div className="flex flex-col gap-2">
              {isLoggedIn && (
                <>
                  <Link to="/dashboard" className="flex items-center gap-3 p-3 rounded-xl hover:bg-gray-50 text-gray-700 font-semibold transition-colors">
                    <span className="material-symbols-outlined text-[#D4AF37]">dashboard</span>
                    Dashboard
                  </Link>
                  <div className="h-px bg-gray-100 my-2"></div>
                </>
              )}

              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className={`flex items-center justify-between p-3 rounded-xl hover:bg-gray-50 group transition-colors ${location.pathname === link.path ? "bg-gray-50 text-[#D4AF37]" : "text-gray-600"}`}
                >
                  <span className="text-lg font-semibold group-hover:text-[#D4AF37] transition-colors">{link.name}</span>
                  <span className="material-symbols-outlined text-gray-400 group-hover:text-[#D4AF37]">chevron_right</span>
                </Link>
              ))}
            </div>

            {/* Bottom Actions (Mobile) */}
            <div className="mt-auto pt-6 border-t border-gray-100 flex flex-col gap-3">
              <button onClick={isOpenPlan} className="w-full bg-[#D4AF37] hover:bg-[#c5a02e] text-[#0B1F33] font-bold text-lg py-3 rounded-xl shadow-md transition-all active:scale-95">
                Plan Event
              </button>

              {/* {isLoggedIn ? (
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center justify-center gap-2 text-red-500 font-semibold py-3 hover:bg-red-50 rounded-xl transition-colors"
                >
                  <span className="material-symbols-outlined">logout</span>
                  Sign Out
                </button>
              ) : (
                <button
                  onClick={isOpenLogin}
                  className="w-full text-center text-lg font-semibold text-[#0B1F33] hover:text-[#D4AF37] py-3 border border-gray-200 rounded-xl transition-all active:scale-95"
                >
                  Log In
                </button>
              )} */}
            </div>
          </div>
        </div>
      </header>

      {/* Spacer to prevent content overlap */}
      <div className="h-[80px]"></div>
    </>
  );
};

export default Header;